import { _ as t } from "../internals/export.js";
import { m as a } from "../internals/math-expm1.js";
var r = Math.cosh,
  s = Math.abs,
  o = Math.E;
t({
  target: "Math",
  stat: !0,
  forced: !r || r(710) === 1 / 0
}, {
  cosh: function cosh(t) {
    var r = a(s(t) - 1) + 1;
    return (r + 1 / (r * o * o)) * (o / 2);
  }
});